import axios from "axios";
import { API_ORIGIN } from "../config/constants";

const authToken = localStorage.getItem("Authtoken");

export class DistrictService {

  //publisher, medium, subject and category single API
  static districtsDetails = async () => {
    try {
      let response = await axios({
        method: "get",
        baseURL: API_ORIGIN + "/cities/districts/all",
      });

      let staticDetails = response.data.data;

      return staticDetails;
    } catch (err) {
      throw err;
    }
  }
}
